import React from "react";
import Field from "../Common/Field";
import MaskedInput from "react-text-mask";

export default class Postcode extends Field {
  pipe(conformedValue) {
    return conformedValue.toUpperCase();
  }

  renderInput() {
    const {
      formikForm,
      isRequired,
      formikField: { value },
      config: { label, name, placeholder, readOnly, disabled },
    } = this.props;
    const mask = [/[1-9]/, /\d/, /\d/, /\d/, /[a-zA-Z]/, /[a-zA-Z]/];

    return (
      <React.Fragment>
        <input type="hidden" name={name} value={value} />
        <MaskedInput
          id={name}
          type="tel"
          className="field__input field__input--text"
          aria-label={label}
          aria-required={!!isRequired}
          value={value}
          readOnly={!!readOnly}
          disabled={!!disabled}
          placeholder={placeholder}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={(e) => {
            formikForm.setFieldValue(name, e.target.value.toUpperCase());
          }}
          guide={false}
          mask={mask}
          pipe={this.pipe}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Postcode.js